export function updateDocumentLocale(i18n: { language: string; dir: () => string }) {
  document.documentElement.setAttribute('lang', i18n.language);
  document.documentElement.setAttribute('dir', i18n.dir());
}
